import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const OwnersIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path
   d="M10,0c-2.3,0-4.17,1.87-4.17,4.17s1.87,4.17,4.17,4.17,4.17-1.87,4.17-4.17S12.3,0,10,0ZM7.5,4.17c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5-1.12,2.5-2.5,2.5-2.5-1.12-2.5-2.5Z"
   fillRule="evenodd"
  />
  <path
   d="M9.63,10C4.77,10,.83,13.94.83,18.8c0,.66.54,1.2,1.2,1.2h15.93c.66,0,1.2-.54,1.2-1.2,0-4.86-3.94-8.8-8.8-8.8h-.74ZM10.37,11.67c3.78,0,6.88,2.94,7.11,6.67H2.51c.24-3.72,3.33-6.67,7.11-6.67h.74Z"
   fillRule="evenodd"
  />
 </svg>,
 "Owners"
);
